import { Container, Row, Col } from "reactstrap";

const UserHeader = ({ adminData }) => {
  return (
    <>
      <div
        className="header pb-8 pt-5 pt-lg-8 d-flex align-items-center"
        style={{
          minHeight: "450px",
          backgroundImage:
            "url(" + require("../../assets/img/theme/areatrekbg.jpg") + ")",
          backgroundSize: "cover",
          backgroundPosition: "center center",
        }}
      >
        <Container className="d-flex align-items-start justify-content-start" fluid>
          <Row>
            <Col lg="7" md="10">
              <h1 className="display-2 text-white">{adminData.firstName} {adminData.lastName}</h1>
              <p className="text-black font-weight-500 mt-0 mb-5">
                Welcome to your Area Trek  dashboard.
                Here you can keep track of user activity, manage matches,
                review profiles.
              </p>
              {/* <Button
                color="info"
                href="#pablo"
                onClick={(e) => e.preventDefault()}
              >
                Admin Profile
              </Button> */}
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default UserHeader;
